import HeaderPaneProps from './HeaderPaneProps';
import { lazyHideFlexPane, lazyShowFlexPane } from 'owa-flex-pane';
import { TimePanel, TimePanelHeaderBar } from 'owa-time-panel';
import * as React from 'react';

const styles = require('./TimePanelPane.scss');

export default class TimePane extends React.Component<HeaderPaneProps, {}> {
    componentDidMount() {
        lazyShowFlexPane.importAndExecute(
            <div className={styles.timesPane}>
                <TimePanel source={'SuiteHeader'} />
            </div>,
            {
                headerText: this.renderHeader,
                onDismiss: this.props.onDismiss,
                className: styles.timeFlex,
                overlayOnSmallWidth: false,
            }
        );
    }

    componentWillUnmount() {
        lazyHideFlexPane.importAndExecute();
    }

    render() {
        return null;
    }

    renderHeader() {
        return <TimePanelHeaderBar />;
    }
}
